import { UserCountryAssignment } from '../../models';

export interface UserCountryAssignmentCountryResponse {
  countryId?: number;
  name?: string;
  code?: string;
  region?: string | { name?: string };
}

export interface UserCountryAssignmentResponse {
  userCountryAssignmentId?: number;
  countryId?: number;
  countryName?: string;
  name?: string;
  country?: UserCountryAssignmentCountryResponse;
  region?: string;
  code?: string;
}

const getRegionName = (region?: string | { name?: string }): string => {
  if (!region) {
    return '';
  }

  return typeof region === 'string' ? region : (region.name ?? '');
};

export const mapUserCountryAssignmentFromResponse = (
  response: UserCountryAssignmentResponse,
  countriesById?: Map<number, CountryLookup>
): UserCountryAssignment => {
  const countryId = response.countryId ?? response.country?.countryId ?? 0;
  const lookup = countriesById?.get(countryId);

  return {
    userCountryAssignmentId: response.userCountryAssignmentId,
    countryId,
    name:
      response.countryName ??
      response.name ??
      response.country?.name ??
      lookup?.name ??
      '',
    region:
      response.region ??
      getRegionName(response.country?.region) ??
      lookup?.region ??
      '',
    code: response.code ?? response.country?.code ?? lookup?.code ?? '',
  };
};

interface CountryLookup {
  name: string;
  region: string;
  code: string;
}

export const toCountryLookupMap = (
  countries: Array<{
    countryId: number;
    name: string;
    region: string;
    code: string;
  }>
): Map<number, CountryLookup> =>
  new Map(
    countries.map(country => [
      country.countryId,
      {
        name: country.name,
        region: country.region,
        code: country.code,
      },
    ])
  );
